import axios from "axios";

const httpClient = axios.create({
    baseURL: "",
    headers: {
        "Content-type": "application/json",
    },
});

// Add response interceptor to handle 401 errors
httpClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('esignature');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default httpClient;
